export default __webpack_public_path__ + "static/media/header_bg.26f3a939.png";